import React, { Fragment } from 'react';

import {
    ajax, buildCreditBoxRequestDto
} from '../components/globals';
import {UIButton, UIMessageBox } from '../components/guiElements';



export class MonetaWebButton extends React.Component {

    constructor(props) {
        super(props);
        this.init = this.init.bind(this);
        this.closePopup = this.closePopup.bind(this);
    }

    closePopup() {
        try {
            window.monetaWebResultHandler = null;
            if (this.popup && !this.popup.closed)
                this.popup.close();
            this.popup = null;
        }
        catch (e) { }
    }

    init() {
        try {
            if (this.props.disabled && this.props.disabled === true)
                return;
            if (!this.props.packetId || this.props.packetId.length == '')
                return;
            if (this.props.loaderShow)
                this.props.loaderShow();
            
            var left = (window.screen.width / 2) - (800 / 2);
            var top = (window.screen.height / 2) - (800 / 2);

            this.closePopup();

            window.monetaWebResultHandler = (result) => {
                try {
                    if (result)
                        this.props.onSuccess(result);
                    else
                        this.props.onError(result)

                    setTimeout(() => { this.closePopup() }, 5000);
                }
                catch(e){

                }
            };

            this.popup = window.open("/monetaWebStart", "_blank", "width=800,height=800,left=" + left + ",top=" + top);
           
            ajax(this, {
                    method: 'post', url: '/api/cbPayment/monetaweb/init',
                    headers: { Authorization: 'Bearer ' + this.props.jwtToken },
                    data: buildCreditBoxRequestDto("MonetaWeb", this.props.packetId),
                },
                response => {
                    if (this.props.loaderHide)
                        this.props.loaderHide();

                    if (response.data.result.data.success) {
                        this.popup.location = response.data.result.data.payload.redirectUrl;
                    }
                    else {
                        this.closePopup();
                        if (this.props.onError)
                            this.props.onError(response.data.result.data.errorMessage);
                    }
                },
                error => {
                    if (this.props.loaderHide)
                        this.props.loaderHide();

                    this.closePopup();

                    if (this.props.onError)
                        this.props.onError(error);
                }
            );
        }
        catch (e) {
            if (this.popup && !this.popup.closed)
                this.popup.close();
            if (this.props.onError)
                this.props.onError("Si e' verificato un errore");
        }

    }
    
    render() {

        return (
            <UIButton className="solid" onClick={this.init} text={this.props.title} disabled={this.props.disabled} />
        );


    }
    
}